<template>
  <modal
    class="editCreditLimit"
    name="setCardChargeModal"
    transition="pop-out"
    :width="modalWidth"
    :height="355"
    @opened="opened"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-5">
          {{ $t("text.retainership.setCardCharge") }}
        </h3>
        <div class="add__retainership__form__wrapper">
          <div class="d-flex justify-content-center">
            <p style="font-weight: 500; font-size: 15px">
              {{ $t("text.retainership.currentCardCharge") }} :
            </p>
            <p class="ml-2">{{ currentCardCharge }}</p>
          </div>
          <div class="form_input_section mt-4">
            <div class="input__div" ref="email_input_div">
              <div class="placeholder_div">
                <img
                  src="@/assets/img/email.png"
                  width="50%"
                  class="input_placeholder_icon"
                />
              </div>
              <div class="input_field_section">
                <input type="text" v-model="chargeAmount" />
              </div>
            </div>
          </div>
          <div ref="email_error_message"></div>
          <div class="text-center mt-5">
            <button
              class="add_quick_fuel_btn"
              @click="setChargeAmount($event)"
              :disabled="isButtonDisabled ? true : null"
              :style="[
                isButtonDisabled
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' },
              ]"
              style="background-color: #46266e"
            >
              {{ $t("text.actionButtons.submit") }} <span></span>
            </button>
            <img
              src="@/assets/img/git_loader.gif"
              style="display: none"
              width="35px"
              class="ml-3 loader"
            />
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 600;

export default {
  name: "editCreditLimit",
  props: ["creditLimit", "email", "currentCardCharge", "companyID"],
  data() {
    return {
      chargeAmount: null,
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeCreditLimit() {
      this.$modal.hide("setCardChargeModal");
    },
    setChargeAmount($event) {
      $event.preventDefault();
      if (!this.chargeAmount) {
        this.$toast.open({
          message: this.$t("text.retainership.enterAmount"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      //changing content type
      const config = configObject.authConfig({ isRemis: true });
      config.headers["Content-Type"] = "application/json";

      let data = {
        customerEpumpId: this.companyID,
        amountPerCard: parseFloat(this.chargeAmount),
      };
      console.log(data);
      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .post(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/SetCardCharge/${this.companyID}?amountPerCard=${this.chargeAmount}`,
          data,
          config
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          data = null;
          this.chargeAmount = null;
          this.$modal.hide("setCardChargeModal");
          this.$toast.open({
            message: this.$t("text.requests.success"),
            type: "success",
            duration: 3000,
          });
          this.$eventHub.$emit("getRetainerships");
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.title,
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    opened() {
      // this.chargeAmount = this.creditLimit;
    },
  },
};
</script>
